import PrintCommon from "app/common/Component/Print/PrintCommon";
import { formatMoney, getDateTime, getImgLogoTreamentPrint, getPrintPatientCode, getSystemConfig , hideMiddleDigits } from "app/common/LocalFunction";
import { toVietnamese } from "app/common/utils/VNUtils";
import React, { memo } from "react";

const FormPrintAllTab = ({ componentRef, allServicePatientData}) => {
    let rowIndex = 1 
    const totalService = allServicePatientData?.patientServiceRegisterList?.reduce(
        (total, sv) => total + (sv.amountActuallyPaid || 0),
    0
    );

    const totalDrug = allServicePatientData?.drugList?.reduce(
        (total, dl) => total + (dl?.price || 0) * (dl?.soldQuantity || 0),
    0
    );

    const totalTreatment = allServicePatientData?.treatmentList?.reduce(
        (total, lt) => total + (lt?.price || 0) * (lt?.quantity || 0),
    0
    );

    const totalCard = allServicePatientData?.prepaidCardList?.reduce(
        (total, cd) => total + (cd?.price || 0) * (cd?.quantity || 0),
    0
    );
    const totalAmount = totalService + totalDrug + totalTreatment + totalCard;
    return (
        <PrintCommon ref={componentRef} marginPage="8mm" hidden={false}>
            <div className="form-container">
                <div className="logo-header">
                    <div className="logo">
                        {getImgLogoTreamentPrint({ height: "100px", width: "150px" })}
                    </div>
                    <div className="clinic-info">
                        <strong>  {getSystemConfig("ORG_NAME")}</strong><br />
                        Địa chỉ: {allServicePatientData?.treatmentList?.[0]?.department?.address || ""}<br />
                        Email: {allServicePatientData?.treatmentList?.[0]?.department?.email || ""}<br />
                        Phone: {allServicePatientData?.treatmentList?.[0]?.department?.phoneNumber || " "}
                    </div>
                </div>

                <h2 className="form-title">DỊCH VỤ KHÁCH HÀNG</h2>

                <h3>I. THÔNG TIN CÁ NHÂN</h3>
                <table className="info-table">
                    <tbody>
                        <tr>
                        <td className="dotted-label">
                            <span>{rowIndex++}. Tên khách hàng:</span>
                            <span className="dots">{allServicePatientData?.patientInfo?.displayName || ""}</span>
                        </td>
                        <td className="dotted-label">
                            <span>Mã khách hàng:</span>
                            <span className="dots">{getPrintPatientCode(allServicePatientData, allServicePatientData?.patientInfo)}</span>
                        </td>
                        </tr>

                        <tr>
                        <td className="dotted-label">
                            <span>{rowIndex++}. Số điện thoại:</span>
                            <span className="dots">{hideMiddleDigits(allServicePatientData?.patientInfo?.phoneNumber) || ""}</span>
                        </td>
                        <td className="dotted-label">
                            <span>Nghề nghiệp:</span>
                            <span className="dots">{allServicePatientData?.patientInfo?.profession?.name || ""}</span>
                        </td>
                        </tr>

                        <tr>
                        <td className="dotted-label">
                            <span>{rowIndex++}. Ngày sinh:</span>
                            <span className="dots">{allServicePatientData?.patientInfo?.birthDate 
                            ? new Date(allServicePatientData.patientInfo.birthDate).toLocaleDateString('vi-VN') 
                            : ''}
                            </span>
                        </td>
                        <td className="dotted-label">
                            <span>Giới tính:</span>
                            <span className="dots">{allServicePatientData?.patientInfo?.gender === 'F' ? 'Nữ' : 'Nam'}</span>
                        </td>
                        </tr>

                        <tr>
                        <td className="dotted-label full-width" colSpan="2">
                            <span>{rowIndex++}. Nguồn:</span>
                           <span className="dots">{allServicePatientData?.patientInfo?.currentPatientSource?.name || ""}</span>
                        </td>
                        </tr>

                        <tr>
                        <td className="dotted-label full-width" colSpan="2">
                            <span>{rowIndex++}. Địa chỉ:</span>
                            <span className="dots">   
                                {[
                                    allServicePatientData?.patientInfo?.currentWard?.name,
                                    allServicePatientData?.patientInfo?.currentDistrict?.name,
                                    allServicePatientData?.patientInfo?.currentProvince?.name
                                ]
                                    .filter(Boolean)
                                    .join(', ')}
                                </span>
                        </td>
                        </tr>
                    </tbody>
                </table>

                <h3>II. THÔNG TIN CHUNG</h3>
                <table className="info-table-service-product">
                    <tbody>
                        <tr>
                        <td className="label-service-product">Tổng Tiền :</td>
                        <td>
                            <span style={{fontWeight:"bold"}}>{formatMoney(totalAmount)}</span>
                        </td>
                        </tr>
                        <tr>
                            <td className="label-service-product">(Bằng chữ) :</td>
                            <td>{toVietnamese(totalAmount || 0)}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h6 style={{ fontWeight: "bold", marginTop: "10px" }}>1). Dịch vụ</h6>
                <div className="table-responsive">
                    <table className="service-table">
                        <thead>
                            <tr>
                            <th>STT</th>
                            <th>TÊN DỊCH VỤ</th>
                            <th>SL</th>
                            <th>ĐƠN GIÁ (VND)</th>
                            <th>THÀNH TIỀN (CẦN THU)</th>
                            <th>TG ĐĂNG KÝ</th>
                            </tr>
                        </thead>
                            <tbody>
                                {allServicePatientData?.patientServiceRegisterList?.map((sv, index) =>(
                                    <tr>
                                    <td>{index + 1}</td>
                                    <td>{sv?.service?.name}</td>
                                    <td>{sv?.quantity}</td>
                                    <td>{formatMoney(sv?.price)}</td>
                                    <td>{formatMoney((sv?.price) * (sv?.quantity))}</td>
                                    <td>{getDateTime(sv.orderDate)}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center", fontWeight: "bold" }}>
                                    TỔNG TIỀN:
                                    </td>
                                    <td style={{ fontWeight: "bold" }}>
                                     {formatMoney(
                                        allServicePatientData?.patientServiceRegisterList?.reduce(
                                        (total, sv) => total + (sv.amountActuallyPaid || 0),
                                        0
                                        )
                                    )}
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>
                    </table>
                </div>

                <h6 style={{ fontWeight: "bold", marginTop: "10px" }}>2). Sản phẩm</h6>
                 <div className="table-responsive">
                    <table className="service-table">
                        <thead>
                            <tr>
                            <th>STT</th>
                            <th>TÊN SẢN PHẨM</th>
                            <th>SL</th>
                            <th>ĐƠN GIÁ (VND)</th>
                            <th>THÀNH TIỀN (CẦN THU)</th>
                            <th>TG ĐĂNG KÝ</th>
                            </tr>
                        </thead>
                            {allServicePatientData?.drugList?.map((dl, index) =>(
                            <>
                                <tbody>
                                    <tr>
                                    <td>{index + 1}</td>
                                    <td>{dl?.drugName}</td>
                                    <td>{dl?.soldQuantity}</td>
                                    <td>{formatMoney(dl?.price)}</td>
                                    <td>{formatMoney((dl?.price) * (dl?.soldQuantity))}</td>
                                     <td>{getDateTime(dl.orderDate)}</td>
                                    </tr>
                                </tbody>
                            </>
                            ))}
                            <tfoot>
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center", fontWeight: "bold" }}>
                                    TỔNG TIỀN:
                                    </td>
                                    <td style={{ fontWeight: "bold" }}>
                                        {
                                            formatMoney(
                                            allServicePatientData?.drugList?.reduce(
                                                (total, dl) => total + (dl?.price || 0) * (dl?.soldQuantity || 0),
                                                0
                                            )
                                            )
                                        }
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>
                    </table>
                </div>

                <h6 style={{ fontWeight: "bold", marginTop: "10px" }}>3). Liệu trình</h6>
                <div className="table-responsive">
                <table className="service-table">
                    <thead>
                    <tr>
                        <th>STT</th>
                        <th>Tên</th>
                        <th>SL</th>
                        <th>Đơn giá (VND)</th>
                        <th>Thành tiền (Cần thu)</th>
                        <th>TG đăng ký</th>
                    </tr>
                    </thead>
                    <tbody>
                    {allServicePatientData?.treatmentList?.map((lt, index) => {
                        let subIndex = 0; // reset mỗi lần sang một liệu trình mới
                        return (
                            <React.Fragment key={index}>
                            <tr style={{ fontWeight: "bold" }}>
                                <td>{index + 1}</td>
                                <td>{lt?.clientCard?.name}</td>
                                <td>{lt?.quantity}</td>
                                <td>{formatMoney(lt?.price)}</td>
                                <td>{formatMoney((lt?.price) * (lt?.quantity))}</td>
                                <td>{getDateTime(lt.startDate)}</td>
                            </tr>

                            {/* Dịch vụ */}
                            {lt?.paServiceRegister?.map((item) => {
                                subIndex++;
                                return (
                                <tr key={`service-${item.id}`}>
                                    <td></td>
                                    <td colSpan="5" style={{ paddingLeft: "20px" }}>
                                        {`${index + 1}.${subIndex}. ${item.service?.name} (x${lt?.quantity}) | Tổng số lần điều trị: `}
                                    <span style={{ fontWeight: "bold" }}>{item.totalPerformedTimes}</span>
                                    <span className="ml-1">/</span>
                                    <span style={{ color: "green" }}>{item.totalTreatmentTimes ?? 0}</span>
                                    </td>
                                </tr>
                                );
                            })}

                            {/* Thuốc */}
                            {lt?.drugs?.map((item) => {
                                subIndex++;
                                return (
                                <tr key={`drug-${item.id}`}>
                                    <td></td>
                                    <td colSpan="5" style={{ paddingLeft: "20px" }}>
                                    {`${index + 1}.${subIndex}. ${item.drugName} (x${item.soldQuantity})`}
                                    </td>
                                </tr>
                                );
                            })}
                            </React.Fragment>
                        );
                    })}

                    </tbody>
                    <tfoot>
                    <tr>
                        <td colSpan="4" style={{ textAlign: "center", fontWeight: "bold" }}>
                        TỔNG TIỀN:
                        </td>
                        <td style={{ fontWeight: "bold" }}>
                        {
                            formatMoney(
                            allServicePatientData?.treatmentList?.reduce(
                                (total, lt) => total + (lt?.price || 0) * (lt?.quantity || 0),
                                0
                            )
                            )
                        }
                        </td>
                        <td></td>
                    </tr>
                    </tfoot>
                </table>
                </div>

                <h6 style={{ fontWeight: "bold", marginTop: "10px" }}>4).Thẻ trả trước</h6>
                <div className="table-responsive">
                    <table className="service-table">
                        <thead>
                            <tr>
                            <th>STT</th>
                            <th>TÊN THẺ</th>
                            <th>SL</th>
                            <th>ĐƠN GIÁ (VND)</th>
                            <th>THÀNH TIỀN (CẦN THU)</th>
                            <th>TG ĐĂNG KÝ</th>
                            </tr>
                        </thead>
                            {allServicePatientData?.prepaidCardList?.map((cd, index) =>(
                                <>
                                    <tbody>
                                        <tr>
                                        <td>{index + 1}</td>
                                        <td>{cd?.clientCard?.name}</td>
                                        <td>{cd?.quantity}</td>
                                        <td>{formatMoney(cd?.price)}</td>
                                        <td>{formatMoney((cd?.price) * (cd?.quantity))}</td>
                                        <td>{getDateTime(cd.startDate)}</td>
                                        </tr>
                                    </tbody>
                                </>
                            ))}
                            <tfoot>
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center", fontWeight: "bold" }}>
                                    TỔNG TIỀN:
                                    </td>
                                    <td style={{ fontWeight: "bold" }}>
                                       {
                                            formatMoney(
                                            allServicePatientData?.prepaidCardList?.reduce(
                                                (total, cd) => total + (cd?.price || 0) * (cd?.quantity || 0),
                                                0
                                            )
                                            )
                                        }
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>
                    </table>
                </div>
            </div>
        </PrintCommon>
    );
};

export default memo(FormPrintAllTab);
